import {useCallback, useEffect} from 'react'
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import constants from 'helpers/constants';
import dom from 'helpers/dom';

const DimensionsProvider = (props) => {
  const postDimensions = useCallback(() => {
    const box = dom.getBbox(document.body);

    const msg = {
      event: 'viqDimensions',
      height: box.height,
      width: box.width,
      scrollHeight: (Math.round(box.height) === document.body.scrollHeight && Math.round(box.height) < box.height) ?
        box.height : document.body.scrollHeight,
      scrollWidth: (Math.round(box.width) === document.body.scrollWidth && Math.round(box.width) < box.width) ?
        box.width : document.body.scrollWidth,
      scrollX: window.scrollX,
      scrollY: window.scrollY
    };

    window.parent.postMessage(JSON.stringify(msg),'*');
  }, []);

  useEffect(() => {
    return utils.observeEvent(window, 'keydown', () => {
      postDimensions();
    }, {timeout: constants.debounce.minimal});
  }, [postDimensions]);

  useEffect(() => {
    return utils.observeEvent(window, 'mousedown', () => {
      postDimensions();
    }, {timeout: constants.debounce.minimal});
  }, [postDimensions]);

  useEffect(() => {
    return utils.observeScroll(window, () => {
      postDimensions();
    }, {timeout: constants.debounce.minimal});
  }, [postDimensions]);

  useEffect(() => {
    return utils.observeResize(window, () => {
      postDimensions();
    }, {timeout: constants.debounce.minimal});
  }, [postDimensions]);

  useEffect(() => {
    return utils.observeResize(document.body, () => {
      postDimensions();
    }, {timeout: constants.debounce.minimal});
  }, [postDimensions]);

  useEffect(() => {
    return utils.observeInterval(() => {
      postDimensions();
    }, constants.delay.dimensions);
  }, [postDimensions]);

  return props.children;
};

DimensionsProvider.propTypes = {
  theme: PropTypes.any
}

export default DimensionsProvider;
